import {ChangeDetectionStrategy, Component, computed, input, output} from '@angular/core';
import {
    ActionButtonComponent,
    ActionLabel,
} from '../../shared/ui/action-button/action-button.component';

@Component({
    selector: 'app-export-now-button',
    standalone: true,
    imports: [ActionButtonComponent],
    template: `
        <app-action-button
            size="sm"
            [label]="label()"
            [busy]="exporting()"
            [disabled]="exporting() || deliveryRequested()"
            (run)="run.emit()" />
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExportNowButtonComponent {
    readonly exporting = input(false);
    readonly deliveryRequested = input(false);
    readonly run = output<void>();

    protected readonly label = computed<ActionLabel>(() => {
        if (this.deliveryRequested()) {
            return {key: 'savedexport_savedexports_action_delivery_requested', module: 'export'};
        }
        if (this.exporting()) {
            return {key: 'quickexports_export_action_exporting', module: 'export'};
        }
        return {key: 'savedexport_savedexports_action_export_now', module: 'export'};
    });
}
